import React from "react";
import Canvas from "../../components/Canvas";

const NotFound = () => {
  return (
    <main className="not-found-page">
      <Canvas />
      <div className="container not-found-content">
        <div className="not-found-code" aria-hidden="true">
          404
        </div>
        <p className="eyebrow">Page not found</p>
        <h1>Looks like this page took a different path.</h1>
        <p className="not-found-copy">
          The page you’re looking for may have moved, been removed, or never
          existed. Let’s get you back somewhere useful.
        </p>
        <div className="actions not-found-actions">
          <a className="button button-primary button-lg" href="/">
            Back to home
          </a>
          <a className="button button-secondary button-lg" href="/contact">
            Contact us
          </a>
        </div>
      </div>
    </main>
  );
};

export default NotFound;
